import React, { Suspense, createContext, useEffect, useMemo, useRef, useState, } from 'react';
import { Outlet } from "react-router-dom";
import { changeCompetition, changeLocale, changeRsc } from 'state-management/actions'
import { useDispatch } from 'react-redux';
import { Collapse, Container } from 'react-bootstrap'


import Clock from 'components/general/Clock';
import Ticker from 'components/common/Ticker';
import HeaderCompetition from 'components/common/main-container/HeaderCompetition';
import { PageHeaderMenu as PageHeader, PageVenueDate } from 'components/common/PageHeader';
import { SEOMetaTags } from 'helpers/seo';
import SelectorTimeZone from 'components/common/selectors/selector-timezone';
import { Expander, PlaceHolderNavBarSecondary } from 'components/common/main-container/NavbarSecondary';
import { useGetConfigSports, useGetLanguages } from 'helpers/commonCodes';
import { useAbsoluteRoot } from 'helpers/urlRoot';
import { useObtainDataArray, getConfigSports, getEventUnits, getEvents, getPositions, getScheduleStartList } from 'data/Querys';
//import ReduxLog from 'components/general/ReduxLog';
import { CanonicalLink, useGetPath, useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import useViewport from 'components/general/useViewPort';
//import RibbonH2H from './ribbon-h2h/RibbonH2H';
import OcsCustomEvents from '../OcsCustomEvents';
import { setLocaleLng } from 'helpers/utils';
import NavBarSecondaryScroll from './NavbarSecondaryScroll';
import Label from 'components/general/Label';
import { lazy } from 'react';
//const NavBarSecondaryScroll = lazy(() => import('./NavbarSecondaryScroll'));
const RibbonH2H = lazy(() => import('./ribbon-h2h/RibbonH2H'));



/*Get Data Related languages and competition*/
export const useLoadDataLanguageCompetitionDiscipline = (mlanguage, mcompetition, mdiscipline) => {
    const { urlRoot } = useAbsoluteRoot();
    let queryArray = [];
    if (mdiscipline) {

        queryArray.push({
            queryKey: ['CC_Events', mcompetition, mdiscipline, mlanguage?.toUpperCase()],
            queryFn: getEvents,
            refetchInterval: 0,
        })

        queryArray.push({
            queryKey: ['CC_EventUnits', mcompetition, mdiscipline, mlanguage?.toUpperCase()],
            queryFn: getEventUnits,
            refetchInterval: 0,
        })

        //Load data from SportCodes CC file
        queryArray.push({
            queryKey: ['CC_Positions', mcompetition, mdiscipline, mlanguage?.toUpperCase()],
            queryFn: getPositions,
            refetchInterval: 0,
        })

        queryArray.push({
            queryKey: ['ConfigSports', mcompetition, mdiscipline, urlRoot],
            queryFn: getConfigSports,
            refetchInterval: 0,
        })

        queryArray.push({
            queryKey: ['getScheduleStartList', mcompetition, mdiscipline, mlanguage],
            queryFn: getScheduleStartList,
            refetchInterval: 15000,
            enabled: !mdiscipline || mdiscipline && mdiscipline.length > 3 ? false : true
        })

    }

    const data = useObtainDataArray({ queries: queryArray });
    const isLoading = data.some(result => result.isLoading)
    const isError = data.some(result => result.isError)
    return ({ isLoading, isError, data })
};

//Excute Something previous to show component 
export const RouteMiddleware = ({ children }) => {

    const { mirs_competition, mirs_language, mirs_discipline, mirs_event, mirs_rsc } = useUrlFriendlyToParameters();
    const dispatch = useDispatch();
    const dataLanguage = useGetLanguages();
    let language = dataLanguage?.languages?.find(item => item.lang === mirs_language?.toUpperCase())?.langIsoCode?.toLowerCase();

    useMemo(() => {
        changeRedux(
            {
                localelang: language,
                competition: mirs_competition,
                rsc: mirs_rsc ? mirs_rsc : mirs_event ? mirs_event : mirs_discipline,
                lang: mirs_language,
                dispatch: dispatch
            })
    }, [mirs_language, mirs_rsc, mirs_event, mirs_discipline]);

    return (
        <div id='mirs-app-content' data-time-stamp={Date.now()}>
            {children}
        </div>
    );
};

/*
const withLogger = (WrappedComponent) => {
    const WithLogger = (props) => {
        const { mirs_language, mirs_competition } = useParams();
        const dispatch = useDispatch();
        const dataLanguage = useGetLanguages()
        let language = dataLanguage?.languages?.find(item => item.lang === mirs_language?.toUpperCase())?.description
        useEffect(() => {
            changeRedux(
                {
                    localelang: language,
                    competition: mirs_competition,
                    lang: mirs_language,
                    dispatch: dispatch
                })
        }, [mirs_language]);
        useEffect(() => {
            // Log data on component mount
            return () => {
                // Log data on component unmount
                console.log(`Component ${WrappedComponent.name} unmounted.`);
            };
        }, []);

        useEffect(() => {
            // Log data on component update
            console.log(`Component ${WrappedComponent.name} updated.`);
        });

        return <WrappedComponent {...props} />;
    };

    WithLogger.displayName = `withLogger(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithLogger;
};
*/

export const changeRedux = ({ competition, lang, localelang, rsc, dispatch }) => {
    //Store in Redux competition
    let localeLanguage = localelang?.toLowerCase() || 'en';
    dispatch(changeCompetition(competition));
    dispatch(changeRsc(rsc));
    dispatch(changeLocale(localeLanguage));
    if (typeof document !== 'undefined') {
        // code that relies on the document object
        document.documentElement.lang = localelang;
        document.documentElement.setAttribute("class", localelang);
    }
    setLocaleLng();

};

export const changeOCSEvent = ({ rsc }) => {
    if (rsc?.length === 3 || rsc?.length === 34 || rsc?.length === 22) {
        sessionStorage.setItem('RSC', rsc)
    }
};

//const NewOutlet = withLogger(ReduxLog);


export default function MainContainer() {
    const { breakPoint } = useViewport()
    const isMobile = breakPoint === 'sm' || breakPoint === 'xs';
    const { mirs_competition, mirs_language, mirs_discipline, mirs_rsc, mirs_event, mirs_code, mirs_noc } = useUrlFriendlyToParameters()
    let obj = useGetPath()
    let objUrl = obj(mirs_language);

    useMemo(() => {
        changeOCSEvent(
            {
                rsc: mirs_rsc ? mirs_rsc : mirs_event ? mirs_event : mirs_discipline ? mirs_discipline : '',
            })
    }, [mirs_rsc, mirs_event, mirs_discipline]);


    const dataConfigSport = useGetConfigSports({ mirs_competition, mirs_discipline });
    const isH2H = dataConfigSport?.isH2H
    let hasRibbon = true
    if (dataConfigSport) {
        hasRibbon = dataConfigSport.hasOwnProperty("hasRibbon") ? dataConfigSport?.hasRibbon : dataConfigSport.hasOwnProperty("hasRibbonFilter") ? (new RegExp(dataConfigSport.hasRibbonFilter)).test(mirs_rsc) : hasRibbon;
    }

    //Expander Variable Ribbon 
    const [open, setOpen] = useState(true);
    const [showBtnResults, setShowBtnResults] = useState(false);

    //const value = useMemo(() => ({ open, setOpen }), [open, setOpen]);
    const value = useMemo(() => ({ expandedComponent: { open, setOpen }, resultBtn: { showBtnResults, setShowBtnResults } }), [open, showBtnResults]);

    useEffect(() => {
        if (isH2H && !isMobile) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [isH2H, isMobile]);

    useEffect(() => {
        setShowBtnResults(hasRibbon)
    }, [mirs_discipline, hasRibbon]);


    //aqui se cargan las units y los schedules minimos,...... Se ve que el titulo va cambiando segun se van cargando estos valores
    const { isLoading } = useLoadDataLanguageCompetitionDiscipline(mirs_language, mirs_competition, mirs_discipline)


    let componentResult;
    let componentVenue;
    let componentDivIDH1;


    if ((objUrl.url.isResult || objUrl.url.isTodayMatches || objUrl.url.isTodayAthMatches || objUrl.url.isTodayTeamMatches)) {//&& process.env.REACT_APP_DEVELOPMENT === 'true'
        componentVenue = <PageVenueDate />
    }
    if ((objUrl.url.isResult || objUrl.url.isPool || objUrl.url.isBracket || objUrl.url.isRanking)) {
        componentDivIDH1 = <div id='extEditorialContent' className='div-below-h1' data-rsc={mirs_rsc}></div>
    }
    if (objUrl.url.isProfileByNoc) {
        componentDivIDH1 = <div id='OCS_Noc_Profile_Injection' className='div-below-h1' data-noc-id={mirs_noc}></div>
    }
    if (objUrl.url.isAthletes) {
        componentDivIDH1 = <div id='OCS_Athletes_Hub_Injection' className='div-below-h1' data-ath-rsc={mirs_rsc}></div>
    }
    if (objUrl.url.isBios || objUrl.url.isTeam || objUrl.url.isCoach || objUrl.url.isHorse || objUrl.url.isOfficial) {
        componentDivIDH1 = <div id='OCS_Athletes_Bios_Injection' className='div-below-h1' data-ath-id={mirs_code}></div>
    }

    //if ((objUrl.url.isResult || objUrl.url.isPool || objUrl.url.isBracket || objUrl.url.isRanking)) {
    if (objUrl.url.isResult) {
        componentResult =
         !isLoading &&  <div className='ribbon-bg-container'>
                <div className="container">
                    <Expander >
                        <Suspense fallback={<></>} ><RibbonH2H /></Suspense>
                    </Expander>
                </div>
            </div>
    }

    return (
        <div id='mirs-app-container'> {/* Id used in Info App */}
            <a href="#maincontent" className="sr-only"><Label data={"LabelSkipContent"} /></a>
            <SEOMetaTags />
            <CanonicalLink />
            <HeaderCompetition />
            <MainContainerContext.Provider value={value}>
                <header id='atos-top' className='header-container'>
                    <PageHeader />
                    {isLoading
                        ? <PlaceHolderNavBarSecondary />
                        : <Suspense fallback={<PlaceHolderNavBarSecondary />}><NavBarSecondaryScroll /></Suspense>
                    }
                </header >
                {componentDivIDH1}
                {componentResult}
            </MainContainerContext.Provider>
            <Ticker />
            <main id="maincontent">
                {componentVenue}
                <Container className="viewsHeight">
                    <>
                        <RouteMiddleware>
                            {!isLoading && <Outlet />}
                        </RouteMiddleware>
                    </>

                    <div id="poweredByFooter">
                        <Label data={'HeaderPoweredBy'}/>
                    </div> 
                </Container>
            </main>
            {/* 
            <section id="mirs-footer-app">
                <FooterCompetition />
            </section>
            */}
            <OcsCustomEvents />
        </div>
    )
}


export const MainContainerContext = createContext({});

